
import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot, query, where, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import "../styles/sideBar.css";

function getMonthRange(monthStr) {
  if (!monthStr || !/^\d{4}-\d{2}$/.test(monthStr)) return null;
  const [y, m] = monthStr.split("-").map(Number);
  const lastDay = new Date(y, m, 0).getDate();
  const mm = String(m).padStart(2, "0");
  return { start: `${y}-${mm}-01`, end: `${y}-${mm}-${String(lastDay).padStart(2, "0")}` };
}

export default function Bills({ isToogle }) {
  const [month, setMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });
  const [trainerEmail, setTrainerEmail] = useState("");
  const [sessions, setSessions] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const range = useMemo(() => getMonthRange(month), [month]);

  useEffect(() => {
    setError("");
    setSessions([]);

    if (!range) return;
    if (!trainerEmail?.trim()) return;

    setLoading(true);

    const q = query(
      collection(db, "sessions"),
      where("instructors", "array-contains", trainerEmail.trim().toLowerCase()),
      where("date", ">=", range.start),
      where("date", "<=", range.end),
      orderBy("date", "asc"),
      orderBy("startTime", "asc")
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setSessions(rows);
        setLoading(false);
      },
      (e) => {
        console.error(e);
        setError("Błąd pobierania. Jeśli Firestore wymaga indeksu (composite), link będzie w konsoli.");
        setLoading(false);
      }
    );

    return () => unsub();
  }, [range, trainerEmail]);

  return (
    <div className={isToogle ? "side-toogle-margin" : "side-margin"} style={{ display: "flex", flexDirection: "column", minHeight: "100vh", padding: 16, gap: 12 }}>
      <div style={{ width: "100%", maxWidth: 1400 }}>
        <h2 style={{ margin: 0 }}>Rozliczenia – zajęcia trenera</h2>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginTop: 12 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            <span style={{ fontSize: 12, opacity: 0.75 }}>Miesiąc</span>
            <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} style={{ padding: "10px 12px", borderRadius: 10, border: "1px solid rgba(0,0,0,0.15)", outline: "none" }} />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 320 }}>
            <span style={{ fontSize: 12, opacity: 0.75 }}>Mail trenera (szukamy po mailach)</span>
            <input value={trainerEmail} onChange={(e) => setTrainerEmail(e.target.value)} placeholder="np. alicja.dluzniak1@gmail.com" style={{ padding: "10px 12px", borderRadius: 10, border: "1px solid rgba(0,0,0,0.15)", outline: "none" }} />
          </div>

          <div style={{ marginLeft: "auto", fontSize: 13, opacity: 0.8 }}>{loading ? "Wczytywanie..." : `Zajęcia: ${sessions.length}`}</div>
        </div>

        {error ? <div style={{ marginTop: 12, padding: 10, borderRadius: 10, background: "rgba(255,0,0,0.08)" }}>{error}</div> : null}

        <div style={{ width: "100%", overflowX: "auto", marginTop: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1100 }}>
            <thead>
              <tr style={{ textAlign: "left" }}>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Data</th>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Godz.</th>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Zajęcia</th>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Lokalizacja</th>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Wiek</th>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Poziom</th>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Slots</th>
                <th style={{ padding: "10px 10px", fontSize: 13, opacity: 0.8, borderBottom: "1px solid rgba(0,0,0,0.12)", whiteSpace: "nowrap" }}>Status</th>
              </tr>
            </thead>

            <tbody>
              {!loading && trainerEmail && sessions.length === 0 ? (
                <tr>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }} colSpan={8}>
                    Brak zajęć dla tego trenera w wybranym miesiącu.
                  </td>
                </tr>
              ) : null}

              {sessions.map((s) => (
                <tr key={s.id} style={{ borderTop: "1px solid rgba(0,0,0,0.08)" }}>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{s.date || ""}</td>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{(s.startTime || "") + (s.endTime ? `–${s.endTime}` : "")}</td>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{s.name || ""}</td>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{s.location || ""}</td>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{(s.minAge ?? "") !== "" || (s.maxAge ?? "") !== "" ? `${s.minAge ?? ""}-${s.maxAge ?? ""}` : ""}</td>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{s.exp || ""}</td>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{s.slots ?? ""}</td>
                  <td style={{ padding: "10px 10px", fontSize: 14, verticalAlign: "top", whiteSpace: "nowrap" }}>{s.status || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: 10, fontSize: 12, opacity: 0.7 }}>
          Uwaga: query może wymagać composite index (instructors + date + orderBy). Jeśli Firestore rzuci błąd, w konsoli dostaniesz link „Create index”.
        </div>
      </div>
    </div>
  );
}
